import { DateTime } from 'luxon'

import { MINUTES_PER_HOUR } from '@/utils/time'

export default function sessionTimeRemoteToLocal({
  startDate,
  endDate,
}: {
  startDate: string
  endDate: string
}): {
  date: string
  time: string
  duration: string
} {
  const startDateTime = DateTime.fromISO(startDate)
  const time = startDateTime.hour + startDateTime.minute / MINUTES_PER_HOUR
  const duration = `${DateTime.fromISO(endDate).diff(startDateTime).as('minutes')}`

  return {
    date: startDateTime.toISO(),
    time: `${time}`,
    duration,
  }
}
